module.exports = __webpack_public_path__ + "static/media/salao_jardim_1.061a73b3.jpg";